module.exports = __webpack_public_path__ + "static/media/fingerprint-green.989a8f30.png";


//////////////////
// WEBPACK FOOTER
// ./src/App/scenes/AppFrame/images/fingerprint-green.png
// module id = 565
// module chunks = 0